/**
 * @file     format.ts
 * @purpose  Locale-free formatting for the owner-listing screens: rents in
 *           whole dollars and short dates from ISO strings, so the server
 *           render and the browser always print the same text.
 */

export function formatRent(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '';
  return `$${Math.round(value).toLocaleString('en-CA')}`;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "Nov 15, 2026" from an ISO date or timestamp, without locale data, so server and client agree. */
export function formatDay(iso: string | null | undefined, withYear = false): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return '';
  const base = `${MONTHS[Number(m[2]) - 1]} ${Number(m[3])}`;
  return withYear ? `${base}, ${m[1]}` : base;
}
